export const ProductComparison = "103b103ee6026137e59f8e40b8e50e5bb7ac87f73e941bde1f72ddadbe6ec1fd";